import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPayloadCreator } from "util/api";

import { useSelector } from "react-redux";

const apiCall = createAsyncThunk(
  "countries/loader",
  apiPayloadCreator("/countries", "get")
);

export const countriesSlice = createSlice({
  name: "countries",
  initialState: { loaded: null, data: {} },
  reducers: {},
  extraReducers: {
    [apiCall.pending]: (state, action) => {
      state.loading = true;
    },
    [apiCall.fulfilled]: (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.data = action.payload;
    },
    [apiCall.rejected]: (state, action) => {
      state.loading = false;
      state.loaded = false;
      state.error = action.payload;
    },
  },
});

countriesSlice.selector = (store) => store.countries;

countriesSlice.asyncActions = {
  load: () => (dispatch) => dispatch(apiCall({})),
};

export function useGeographicalLocations() {
  const countries = useSelector(countriesSlice.selector).data;
  const locationLookup = Object.fromEntries(
    countries.map((c) => [
      c.symbolic_id,
      {
        ...c,
        full_label: c.label,
        country_id: c.id,
        country_symbolic_id: c.symbolic_id,
        isCountry: true,
      },
    ])
  );
  countries.forEach((c) => {
    if (c.has_fixed_area_choices) {
      c.administrative_areas.forEach((a) => {
        locationLookup[a.symbolic_id] = {
          ...a,
          full_label: a.label + ", " + c.label,
          country_id: c.id,
          country_symbolic_id: c.symbolic_id,
        };
      });
    }
  });

  return {
    countries,
    locationLookup,
  };
}

export default countriesSlice.reducer;
